import React from 'react';
// analyticsClient.ts
import { PostHogProvider, usePostHog } from 'posthog-js/react';
import { useThemeSettings } from '../../ThemeProvider';
import i18n from '../../localization/i18n';

export function ExtendedPostHogProvider({ children }: { children: React.ReactNode }) {
  if (process.env.EXPO_PUBLIC_DISABLE_TRACKING === 'true') {
    return <>{children}</>;
  }
  const posthog = usePostHog()
  const { isDark } = useThemeSettings();
  posthog.register({
    theme: isDark ? 'dark' : 'light',
    locale: i18n.language,
  });
  return (
    <PostHogProvider client={posthog}>
      {children}
    </PostHogProvider>
  );
}
